<template>
    <div class="search-group broker">
        <div class="tab-header">
            <im-popper
                ref="popper"
                @popperStatusChange="popperStatusChange"
                :offset="offset"
                popperClass="md-hero__broker-popper"
                :appendToBody="false"
            >
                <template v-slot:reference>
                    <div
                        class="input_prepend"
                        :class="{ 'is-popper': showPopper }"
                    >
                        {{ searchGroupTabs[activeIndex].mobileModelName }}
                        <span class="iconfont icon-arrow_04_down"></span>
                    </div>
                </template>
                <template v-slot:default>
                    <ul class="popper_wrapper">
                        <li
                            :class="`option ${
                                activeIndex === index ? 'active' : ''
                            }`"
                            @click="changeType(index)"
                            :key="obj.value"
                            v-for="(obj, index) in searchGroupTabs"
                            v-html="obj.mobileModelName"
                        ></li>
                    </ul>
                </template>
            </im-popper>
        </div>
        <div class="tab-body">
            <div
                v-for="(item, index) in searchGroupTabs"
                :key="item.id"
                :class="`tab-content ${activeIndex === index ? 'active' : ''}`"
            >
                <component
                    :is="searchBar"
                    v-if="item.inputComponentType === 'searchBar'"
                    v-show="activeIndex === index"
                    :placeholder="searchGroupConfig['placeholder-search']"
                    :submitText="item.submitText"
                />
                <address-input
                    v-if="item.inputComponentType === 'addressInput'"
                    v-show="activeIndex === index"
                    :placeholder="
                        searchGroupConfig[
                            item.id === 1
                                ? 'placeholder-sell'
                                : 'placeholder-eval'
                        ]
                    "
                    v-model:searchText="searchText"
                    :submitText="item.submitText"
                    :chooseSuggestionAutoSubmit="false"
                    :mobileScroll="false"
                    icon="icon-v5-search"
                    @submitAddress="
                        (address, data, callback) =>
                            submitAddress(
                                { address, data, callback },
                                index,
                                item.submitType,
                                item.submitUrl
                            )
                    "
                />
            </div>
        </div>
        <div
            v-if="agreementData && agreementData.agreement"
            class="agreement-container"
        >
            <a
                :href="agreementData.agreementUrl || ''"
                class="agreement"
                target="_blank"
                rel="noopener noreferrer"
            >{{ agreementData.agreement }}</a
            >
        </div>
    </div>
</template>

<script>
import common from '../search-group';
import mixinsSearchBar from './mixins-search-bar';
import AddressInput from '../../../components/address-input/standard.vue';
export default {
    mixins: [common, mixinsSearchBar],
    data: function() {
        return {
            offset: [0, 3],
            activeIndex: 0,
            showPopper: false,
            popper: null
        };
    },
    components: {
        AddressInput
    },
    mounted() {
        this.popper = this.$refs['popper'];
    },
    methods: {
        popperStatusChange(val) {
            this.showPopper = val;
        },
        changeType(i) {
            this.activeIndex = i;
            this.popper.hide();
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '@/theme/mixin.scss';
.search-group.broker {
    --input-height: 60px;
    --radius: 5px;
    margin-top: 20px;
    width: 100%;
    padding: 30px;
    display: flex;
    @include placeholderMix(var(--font-normal), var(--color-info), 16px);
    @include media-600 {
        @include placeholderMix(var(--font-normal), var(--color-info), 14px);
    }
    .tab-header {
        font-size: 16px;
        color: var(--color-text);
        font-family: var(--font-medium);
        position: relative;
        .input_prepend {
            background-color: #fff;
            border-top-left-radius: var(--radius);
            border-bottom-left-radius: var(--radius);
            padding: 0 30px;
            height: var(--input-height);
            display: flex;
            align-items: center;
            position: relative;
            white-space: nowrap;
            .iconfont {
                font-size: 12px;
                margin-left: 15px;
                transform: rotate(0deg);
                transition: transform 0.3s ease;
                vertical-align: middle;
            }
            &.is-popper {
                .iconfont {
                    transform: rotate(180deg);
                }
            }
            &:after {
                content: '';
                position: absolute;
                right: 0;
                height: 20px;
                border-right: 1px solid rgba(0, 0, 0, 0.2);
            }
        }
        .md-hero__broker-popper {
            width: 100%;
            min-width: 60px;
            .popper_wrapper {
                border-radius: var(--radius);
                .option {
                    height: var(--input-height);
                    background-color: #fff;
                    line-height: var(--input-height);
                    text-align: center;
                    cursor: pointer;
                    &:first-child {
                        border-top-right-radius: var(--radius);
                        border-top-left-radius: var(--radius);
                    }
                    &:last-child {
                        border-bottom-left-radius: var(--radius);
                        border-bottom-right-radius: var(--radius);
                    }
                    &.active {
                        color: var(--color-theme);
                    }
                    &:hover {
                        background-color: #e5e5e5;
                    }
                }
            }
        }
    }

    .tab-body {
        width: 100%;
        .tab-content {
            width: 100%;
            display: none;
            &.active {
                display: block;

                .address-input {
                    height: var(--input-height);
                    width: 100%;
                    box-shadow: none;
                    @include media-600 {
                        background-color: transparent;
                        &.standard .left-box .icon-search {
                            display: none;
                        }
                    }
                    .left-box input {
                        padding-left: 20px;
                        font-family: var(--font-medium);
                        font-size: 16px;
                        color: var(--color-text);
                        @include media-600 {
                            padding-left: 10px;
                            padding-right: 20px;
                            font-size: 14px;
                        }
                    }
                    .left-box {
                        @include placeholderMix(
                            var(--font-normal),
                            var(--color-info),
                            16px
                        );
                        @include media-600 {
                            @include placeholderMix(
                                var(--font-normal),
                                var(--color-info),
                                14px
                            );
                        }
                    }
                    .right-box {
                        .iconfont {
                            display: none;
                        }
                        .submit-btn {
                            @include color-button-hover();
                            height: var(--input-height);
                            line-height: var(--input-height);
                            border-top-right-radius: var(--radius);
                            border-bottom-right-radius: var(--radius);
                            @include color-button();
                            .iconfont {
                                font-size: 25px;
                            }
                        }
                        @include media-600 {
                            display: flex;
                        }
                    }
                }
            }

            .search-bar {
                background-color: transparent;
                width: 100%;
                padding: 0;
                > .title,
                > .keyword-submit,
                .condition-search,
                .search-by-section .label {
                    display: none;
                }

                .search-by-section {
                    .search-category {
                        margin-top: 0;
                        box-shadow: none;
                    }
                }
            }
            input {
                height: var(--input-height);
            }
        }
    }
    .agreement-container {
        width: 100%;
        margin-top: 20px;
        .agreement {
            width: 100%;
            font-size: 12px;
            text-align: center;
            @include webkitBox(3);
            line-height: 14px;
            color: #fff;
            &:hover {
                @include color-hover();
                @include media-800 {
                    color: #fff;
                }
            }
        }
    }
    @include media-600 {
        .tab-header {
            .input_prepend {
                padding: 0 10px;
            }
        }
    }
}
</style>
